import {
  AnimatedCurrencyValue,
  CurrencyValue,
  Flex,
  PercentageValue,
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from '@blockanalitica/ui';
import { PercentageValueOptions } from '@blockanalitica/ui/package/types/src/components/molecules/PercentageValue';
import { ReactNode } from 'react';

type AnimatedCurrencyValueOptions = Omit<
  React.ComponentProps<typeof AnimatedCurrencyValue>['options'],
  'trendIcon'
>;
type CommonOptions = AnimatedCurrencyValueOptions &
  Omit<PercentageValueOptions, 'trendIcon'>;

export interface Options extends CommonOptions {
  trendIcon?: boolean | ReactNode;
}
export interface TooltipChangeProps {
  field: string;
  data: ReactNode;
  formatPercentageOptions?: PercentageValueOptions['formatPercentageOptions'];
  options?: Options;
  percentage?: boolean;
}

export default function CurrencyTooltipChange({
  field,
  data,
  formatPercentageOptions,
  percentage = false,
  options
}: TooltipChangeProps) {
  const fieldBase = field;
  const trendBase = `${fieldBase}_change`;
  const trendPercBase = `${trendBase}_percentage`;
  const tooltipContent = percentage ? (
    <>
      <PercentageValue
        fontSize={'0'}
        value={Number(data[trendPercBase])}
        options={{
          tooltip: false,
          trend: true,
          trendIcon: true,
          formatPercentageOptions: formatPercentageOptions || {
            maximumFractionDigits: 2
          },
          ...options
        }}
      />
    </>
  ) : (
    <>
      <TooltipTrigger>
        <CurrencyValue
          value={Number(data[trendBase])}
          options={{
            notation: 'compact',
            tooltip: false,
            iconSize: '-1',
            trend: true
          }}
        />
      </TooltipTrigger>
      <TooltipContent>
        <PercentageValue
          fontSize={'0'}
          value={Number(data[trendPercBase])}
          options={{
            tooltip: false,
            formatPercentageOptions: formatPercentageOptions || {
              maximumFractionDigits: 2
            }
          }}
        />
      </TooltipContent>
    </>
  );

  return (
    <Flex
      alignItems="baseline"
      gap="xs"
      width="95%"
      fontSize="1"
      flexDirection={['column', 'row']}>
      <AnimatedCurrencyValue
        value={Number(data[fieldBase])}
        variant={options?.variant || 'dynamic'}
        options={{
          currency: options?.currency || '',
          iconSize: options?.iconSize || '3',
          notation: options?.notation || 'standard',
          tooltip: options?.tooltip || false
        }}
      />
      <Tooltip>{tooltipContent}</Tooltip>
    </Flex>
  );
}
